export const light: ThemeType = {
  name: 'light',
  color: {
    interactive: '#2520EF',
    muted: '#899598',
  },
};

export type ThemeType = {
  name: string;
  color: {
    interactive: string;
    muted: string;
  };
};
